@if (item) {
  <sui-badge [text]="text" [variant]="variant"></sui-badge>
} @else {
  <span class="empty-value">—</span>
}
